import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { EventEmitter } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { LgpdService } from "../../../services/lgpd.service";
declare var $: any;
@Component({
  templateUrl: "./aceite-termos-lgpd.component.html",
  selector: "aceite-termos-lgpd",
  styleUrls: ["./aceite-termos-lgpd.component.css"],
})
export class AceiteTermosLGPDComponent implements OnInit, OnChanges {
  @Input() mostrarModal: boolean;

  @Output("onFecharModal") fecharModal = new EventEmitter<{
    confirmado: boolean;
  }>();

  permitirUsoImagem = false;
  permitirUsoDados = false;

  urlDownloadTermoUsoImagem = "";
  urlDownloadPoliticaPrivacidade = "";

  constructor() {}
  onConfirmado() {
    this.fecharModal.emit({ confirmado: true });
  }
  onCancelado() {
    $("#termo-lgpd-modal").modal("hide");
    this.fecharModal.emit({ confirmado: false });
  }
  ngOnInit(): void {
    this.permitirUsoDados = false;
    this.permitirUsoImagem = false;
    this.urlDownloadTermoUsoImagem =
      environment.urlApiLGPD +
      "/api/lgpd/termo/sistema/SISPAC/TERMO_USO_IMAGEM_VOZ/pdf";
    this.urlDownloadPoliticaPrivacidade =
      environment.urlApiLGPD +
      "/api/lgpd/termo/sistema/SISPAC/TERMO_DADOS_PESSOAIS/pdf";

    $("#termo-lgpd-modal").on("hide.bs.modal", (e) => {
      this.fecharModal.emit({ confirmado: false });
    });
    this.setupModal();
  }
  setupModal() {
    if (this.mostrarModal) {
      $("#termo-lgpd-modal").modal({
        keyboard: false,
        backdrop: "static",
        show: true,
      });
    } else {
      $("#termo-lgpd-modal").modal("hide");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.setupModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/termos-lgpd/aceite-termos-lgpd.component.ts